export default "__VITE_ASSET__15f07ae8__"